module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Video-camera-9acad6cd10c1b6f1372cbaeff2d5bf37.svg";